import { observer } from "mobx-react"
import { useNavigate, useParams } from "react-router-dom"
import { dishState } from "./DishState";
import { useEffect } from "react";
import { MinusOutlined, PlusOutlined, ShoppingCartOutlined } from '@ant-design/icons';
import { Button, Input, InputNumber, Space, Tabs } from "antd";
import './dish.css'
import formatCurrency from "../../utilities/helpers/FormatCurrency";

const Dish = ()=>{
    const {id} = useParams();
    const navigate = useNavigate();
    var id_NumberType = Number(id);
    if(isNaN(id_NumberType) || !id){
        navigate('/not-found')
    }
    useEffect(()=>{
            dishState.getDishInfo(id_NumberType, navigate);
    },[id_NumberType, navigate])
    return(<>
        {!dishState.isGettingDishInfoStatus ? (<>
        <div className="dish container mx-auto">
            <div className="dish-main-info gap-8 p-5 bg-slate-50 lg:flex">
                <div className="dish-image-container w-96 h-72 max-lg:mx-auto">
                    <img className="w-full h-full object-cover object-center rounded-md" src={dishState.dishInfo.img} alt="" />
                </div>
                <div className="dish-info-container flex-1 flex flex-col gap-1">
                    <div className="dish-name text-2xl font-semibold">{dishState.dishInfo.name}</div>
                    <div className="dish-price text-red-500 text-3xl font-bold py-2 rounded-md">
                        {formatCurrency(dishState.dishInfo.price)}
                    </div>
                    {/* <div className="dish-variant grid grid-cols-5">
                        <div>Phân loại:</div>
                        {dishState.dishVariantList.length === 0 ? (<span>(không có phân loại)</span>):
                        (<div className="flex gap-2 flex-wrap justify-start col-span-4">
                        {dishState.dishVariantList.map((item:any, index:number)=>(
                            <Button type={dishState.variantChosenID === item.id ? 'primary' : 'default'} className="border-dashed border-red-500 rounded-3xl bg-red-100" danger onClick={()=>{dishState.handleVariantBtnAction(item.id)}}>{item.name}</Button>
                        ))}
                        </div>)}
                    </div> */}
                    <div className="dish-variant grid grid-cols-5 py-2">
                        <div>Số lượng:</div>
                        <div className="col-span-4">
                            <Space.Compact>
                                <Button type="default" danger icon={<MinusOutlined/>} onClick={()=>{dishState.handleQuantityOrderingButton('minus')}}/>
                                <InputNumber
                                    value={dishState.orderingQuantity}
                                    onKeyDown={(event)=>{dishState.handleQuantityOrderingKeyPress(event)}} //handle the pressing action, preventing unwanted letter
                                    onChange={(event)=>{dishState.orderingQuantity = Number(event)}}
                                    min={0} max={100} status="error" controls={false}/>
                                <Button type="default" danger icon={<PlusOutlined/>} onClick={()=>{dishState.handleQuantityOrderingButton('plus')}}/></Space.Compact>
                        </div>
                    </div>
                    <div className="dish-note">
                        <Button className="p-0 underline" type="link" onClick={()=>{dishState.handleLeaveNoteAction()}} danger>Để lại lưu ý cho nhân viên:</Button>
                        <Input onChange={(event)=>{dishState.noteContent = event.target.value}} className={dishState.isOpeningNote === !true ? "" : 'hidden'}></Input>
                    </div>
                    <div className="dish-action flex justify-end gap-2 pt-2 flex-wrap">
                        <Button className="p-5 text-xl" onClick={(event:any)=>{dishState.addCartAction(event, dishState.dishInfo)}} type="default" danger icon={<PlusOutlined/>}>Thêm vào giỏ hàng</Button>
                        <Button className="p-5 text-xl" onClick={(event:any)=>{dishState.buyNowAction(event, dishState.dishInfo, navigate)}} type="primary" danger icon={<ShoppingCartOutlined/>}>Mua ngay</Button>
                    </div>
                </div>
            </div>
            <div className="dish-other-info mt-4 p-5 bg-slate-50">
                <Tabs tabBarGutter={8}
                    // onChange={onChange}
                    type="card"
                    items={
                        [{label: (<div className="text-black">Thông tin nguyên liệu</div>),
                            key: '1',
                            children: `${dishState.dishInfo.ingredient}`
                        },
                        {label: (<div>Đánh giá</div>),
                            disabled: true,
                            key: '2',
                            children: `${dishState.dishInfo.ingredient}`
                        }]
                    }
                />
            </div>
        </div>
        </>):(<></>)}
    </>)
}
export default observer(Dish)